/** 倍率の範囲と表示・読み取り（食事シートの下の帯と、お気に入りの一覧で共通） */

const MIN_MULTIPLIER = 0.1
export const MAX_MULTIPLIER = 100

/** 1 → "1.0"、1.5 → "1.5"、0.25 → "0.25" */
export function formatMultiplier(value: number): string {
  return Number.isInteger(value) ? value.toFixed(1) : String(Math.round(value * 100) / 100)
}

/** 打った文字が倍率として使えるなら数値を返す（空欄・範囲外は null） */
export function parseMultiplier(raw: string): number | null {
  const value = Number(raw)
  if (raw.trim() === '' || !Number.isFinite(value)) return null
  if (value < MIN_MULTIPLIER || value > MAX_MULTIPLIER) return null
  return value
}
